import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const screenshots = [{
  src: 'https://cdn.magicpatterns.com/uploads/he2FSS5ndBMo9KpxDwKhNi/RESENAS_FACEBOOK.png',
  alt: 'Reseñas reales de mamás en Facebook',
  label: 'Comentarios reales en Facebook'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nDv6nRzWdt6sUNjfvT8Qbc/RESENAS_WPP.png',
  alt: 'Mensajes reales de mamás por WhatsApp',
  label: 'Mensajes reales por WhatsApp'
}];
export function Testimonials() {
  return <section className="py-12 md:py-20 px-5 md:px-6 bg-white" data-id="element-167">
      <div className="max-w-5xl mx-auto" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-14" data-id="element-169">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D1F1A] tracking-tight" data-id="element-170">
            MAMÁS <em className="text-[#F9A8B7] not-italic" data-id="element-171">REALES</em>,
            RESULTADOS <em className="text-[#A9D7E2] not-italic" data-id="element-172">REALES</em>
          </h2>
          <p className="text-base md:text-xl text-gray-600 mt-3 md:mt-4 italic" data-id="element-173">
            Capturas{' '}
            <span className="not-italic font-bold text-[#2D1F1A]" data-id="element-174">
              sin filtro
            </span>{' '}
            de mamás que ya probaron la guía
          </p>
        </motion.div>

        <div className="space-y-8 md:space-y-12" data-id="element-175">
          {screenshots.map((shot, index) => <motion.figure key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-[#FFF1F4] p-3 md:p-6 rounded-3xl shadow-md border border-[#F9A8B7]/20" data-id="element-176">
              <img src={shot.src} alt={shot.alt} loading="lazy" className="w-full h-auto rounded-2xl shadow-sm" data-id="element-177" />
              <figcaption className="text-center text-xs md:text-sm font-bold text-[#2D1F1A]/70 mt-3 md:mt-4 italic" data-id="element-178">
                ✨ {shot.label}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}